/**
 * Created by wwei on 2017-09-20.
 */

import request from 'superagent';

export default function writeLog(action, category, msg) {
    if (sessionStorage.getItem('fname') !== undefined
        && sessionStorage.getItem('fname') !== null
        && sessionStorage.getItem('lname') !== undefined
        && sessionStorage.getItem('lname') !== null) {
        return request.post('/api/log').withCredentials()
            .send({
                "operation": action,
                "category": category,
                "message": msg,
                "fname": sessionStorage.getItem('fname'),
                "lname": sessionStorage.getItem('lname')
            }).then();
    }
}



// WEBPACK FOOTER //
// ./src/common/functions/LogUtil.js